import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, normalizeStyle as _normalizeStyle, isRef as _isRef, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/gongdan_ic_shoudong@2x.png'
import _imports_1 from '@/assets/icon/ic_ar@2x.png'
import _imports_2 from '@/assets/icon/ic_close@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-8e9aed04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg" }
const _hoisted_2 = { class: "bg_cate" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "bg_list"
}
const _hoisted_5 = { class: "bg_list_item" }
const _hoisted_6 = { class: "bg_list_item_top" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg_list_item_top_left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg_list_item_top_left_x" }),
  /*#__PURE__*/_createElementVNode("span", null, "投料明细")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "手动录入", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "bg_list_item_h" }
const _hoisted_12 = { class: "bg_list_item_num" }
const _hoisted_13 = { class: "bg_list_item_num_item" }
const _hoisted_14 = { class: "bg_list_item_num_item_wl" }
const _hoisted_15 = { class: "bg_list_item_num_item_wl_lx" }
const _hoisted_16 = {
  key: 0,
  class: "green"
}
const _hoisted_17 = {
  key: 1,
  class: "yellow"
}
const _hoisted_18 = {
  key: 2,
  class: "red"
}
const _hoisted_19 = { class: "bg_list_item_num_item_sr" }
const _hoisted_20 = ["onUpdate:modelValue", "disabled", "onBlur"]
const _hoisted_21 = {
  key: 1,
  class: "kong"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无数据", -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "bg_list_item" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg_list_item_top" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg_list_item_top_left" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "bg_list_item_top_left_x" }),
    /*#__PURE__*/_createElementVNode("span", null, "产出明细")
  ])
], -1))
const _hoisted_26 = { class: "bg_list_item_h" }
const _hoisted_27 = { class: "bg_list_item_num" }
const _hoisted_28 = { class: "bg_list_item_num_item" }
const _hoisted_29 = { class: "bg_list_item_num_item_sr" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "bg_list_item_h" }
const _hoisted_32 = { class: "bg_list_item_num" }
const _hoisted_33 = { class: "bg_list_item_num_item" }
const _hoisted_34 = { class: "bg_list_item_num_item_sr" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "bg_list_item_h" }
const _hoisted_37 = { class: "bg_list_item_num" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "不良项", -1))
const _hoisted_39 = { class: "bg_list_item_num_item_sr" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg_plan_label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "报工时长")
], -1))
const _hoisted_42 = { class: "bg_plan_label_val" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_44 = {
  key: 0,
  class: "bg_list_item"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg_list_item_top" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg_list_item_top_left" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "bg_list_item_top_left_x" }),
    /*#__PURE__*/_createElementVNode("span", null, "工资绩效")
  ])
], -1))
const _hoisted_46 = { class: "bg_list_item_h" }
const _hoisted_47 = { class: "bg_list_item_num" }
const _hoisted_48 = { class: "bg_list_item_num_item" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "计件方式", -1))
const _hoisted_50 = { class: "bg_list_item_num_item_list" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { class: "bg_list_item_num" }
const _hoisted_53 = { class: "bg_list_item_num_item" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "工资单价", -1))
const _hoisted_55 = { class: "bg_list_item_num_item_sr" }
const _hoisted_56 = { class: "color1" }
const _hoisted_57 = { class: "bg_list_item_num" }
const _hoisted_58 = { class: "bg_list_item_num_item" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "预计工资", -1))
const _hoisted_60 = { class: "bg_list_item_num_item_sr" }
const _hoisted_61 = { class: "color1" }
const _hoisted_62 = { class: "bg_list_item_num" }
const _hoisted_63 = { class: "bg_list_item_num_item" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "达标率", -1))
const _hoisted_65 = { class: "bg_list_item_num_item_sr" }
const _hoisted_66 = { class: "color1" }
const _hoisted_67 = {
  key: 1,
  class: "details_dj"
}
const _hoisted_68 = { class: "details_dj_list" }
const _hoisted_69 = { class: "details_dj_list_item" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bh_zw" }, null, -1))
const _hoisted_71 = { class: "bg_footer" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "新增点检", -1))
const _hoisted_74 = [
  _hoisted_72,
  _hoisted_73
]
const _hoisted_75 = { class: "tg" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tg_header" }, "请确认报工信息", -1))
const _hoisted_77 = { class: "tg_table" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tg_table_header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tg_table_header_item" }, "类型"),
  /*#__PURE__*/_createElementVNode("div", { class: "tg_table_header_item" }, "物料名称"),
  /*#__PURE__*/_createElementVNode("div", { class: "tg_table_header_item" }, "物料数量")
], -1))
const _hoisted_79 = {
  key: 0,
  class: "nr"
}
const _hoisted_80 = { class: "tg_table_nr_item" }
const _hoisted_81 = { class: "tg_table_nr_item" }
const _hoisted_82 = {
  key: 1,
  class: "nr"
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tg_table_nr" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tg_table_nr_item1" }, "暂无数据")
], -1))
const _hoisted_84 = [
  _hoisted_83
]
const _hoisted_85 = { class: "tg_footer" }
const _hoisted_86 = { class: "bl" }
const _hoisted_87 = { class: "bl_head" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {"opacity":"0"},
  alt: ""
}, null, -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "不良项", -1))
const _hoisted_90 = { class: "bl_list" }
const _hoisted_91 = ["onClick"]
const _hoisted_92 = { class: "bl_list_item_left" }
const _hoisted_93 = ["checked"]
const _hoisted_94 = { class: "bl_list_item_right" }
const _hoisted_95 = ["onUpdate:modelValue"]

import { getCurrentInstance, nextTick, onMounted, ref, reactive, computed, onActivated } from 'vue'
    import { useRouter, useRoute } from "vue-router"
    import { Dialog, Toast } from 'vant'
    import { REGULAR } from '@/utils/utils'
    import { categoryExtList, queryOne, queryList } from '@/apis/PlanningAPI'
    import {
        getBarcodeContent,
        queryById,
        getOrocessRecord,
        deleteCT,
        updateById,
        comfirmDone,
        comfirmDoneStandard,
        getListByCondition,
        allForStandard,
        pageDJ,
        deletedj,
        dealWorkorderRecordStandard,
        getWorkorderRecordListStandard
    } from '@/apis/WorkOrderAPI'
    import { QRCodeType } from '@/enum'
    import VWorkOrderInfo from '@/components/common/WorkOrderInfo.vue'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const { proxy }: any = getCurrentInstance()
    const { $Bus }  = getCurrentInstance().appContext.config.globalProperties
    const router = useRouter()
    const route = useRoute()

    let TimeShow = ref(false)

    let from: any = reactive({
        time: '',
        defective: [],
        defectiveName: '',
        durationName: '0小时0分钟',
        duration: 0,
        index: 0
    })

    let cate = ref([{ name: '生产' }, { name: '点检' }])
    let typeView = ref(0)

    const clickIten = (i: number) => {
        typeView.value = i
        if (i === 1) {
            finished.value = false
            page.capacity = 1
            pageDJs()
        }
    }

    // 预计工资
    const expectedSalary = computed(() => {
        if (arrType.value.length === 0) return 0;
        // 按件计算
        if (arrType.value[from.index].type == 0) {
            if (!produceFrom.qualified) return 0
            if (arrType.value[from.index].unqualified == 1) {   // 是否计入不良品
                let total = Number(produceFrom.qualified) + Number(produceFrom.undesirable)
                return (total * (arrType.value[from.index].salary / 100)).toFixed(2) || 0
            } else {
                return (Number(produceFrom.qualified) * (arrType.value[from.index].salary / 100)).toFixed(2) || 0
            }
        } else {
            if (!from.duration) return 0;
            let h = (from.duration / 60 / 60).toFixed(2)
            return (Number(h) * (arrType.value[from.index].salary / 10 / 10)).toFixed(2) || 0
        }
    })

    // 达标率
    const complianceRate = computed(() => {
        if (arrType.value.length === 0) return 0;
        if (!produceFrom.qualified && !produceFrom.undesirable) return 0;
        if (!from.duration) return 0;
        if (!arrType.value[from.index].num) return 0;
        // 按件计算
        // if (infoBox.value.type == 0) {
            if (arrType.value[from.index].unqualified == 1) {   // 是否计入不良品
                let a = ((Number(produceFrom.qualified) + Number(produceFrom.undesirable)) / (from.duration / 3600)).toFixed(2)
                let b = (arrType.value[from.index].num / (arrType.value[from.index].times / 3600)).toFixed(2)
                console.log(a)
                console.log(b)
                return ((Number(a) / Number(b)) * 100).toFixed(2)
                // let total = (Number(from.qualified) + Number(from.undesirable)) / ((from.duration * 60 * 60) * infoBox.value.num / )
                // return total * infoBox.value.salary;
            } else {
                let a = (produceFrom.qualified / (from.duration / 3600)).toFixed(2)
                let b = (arrType.value[from.index].num / (arrType.value[from.index].times / 3600)).toFixed(2)
                console.log(a)
                console.log(b)
                return ((Number(a) / Number(b)) * 100).toFixed(2)
                // return Number(from.qualified) * infoBox.value.salary;
            }
        // } else {
        //     console.log('按时长')
        // }
    })

    const loading = ref(false);
    const finished = ref(false);
    let show = ref(false)
    // 点检数据
    let djData: any = ref([])
    // 分页查询数据
    let page = reactive({
        capacity: 10,
        page: 0
    })

    let infoBox: any = ref(null)     // 工资绩效

    // 产出合格/不良
    let produceFrom: any = reactive({
        qualifiedId: '',
        qualified: '',  // 合格
        undesirableId: '',
        undesirable: '' // 不良
    })

    let cateList:any = ref([])  // 不良项

    // 详情数据
    const info: any = ref({})

    // 判断是否能提交
    let isSubmit: any = ref<boolean>(false)

    // 不良明细
    let undesirable: any = ref([])

    // 报废明细
    let scrap: any = ref([])

    // 扫码类型
    let type: any = ref('')

    let arrType: any = ref([])

    // 统计数据
    let statisticsData: any = ref([
        // {
        //     name: '工单投料',
        //     materialName: '黄沙',
        //     num: 0
        // },
        // {
        //     name: '工单合格产出',
        //     materialName: '黄沙',
        //     num: 0
        // },
        // {
        //     name: '工单不良产出',
        //     materialName: '黄沙',
        //     num: 0
        // },
        // {
        //     name: '工单未投料',
        //     materialName: '黄沙',
        //     num: 0
        // }
    ])

    // 投料数据
    const feedingData: any = ref([])

    // 产出数据
    const produceData: any = ref([])

    // 控制扫码显示隐藏
    const openCode = ref<boolean>(false)

    // 控制报工统计
    const statistics = ref<boolean>(false)

    const changeChecked = (i: number) => {
        cateList.value[i].active = !cateList.value[i].active
    }

    const getData = () => {
        categoryExtList({
            cateType: "3"
        }).then(res => {
            if (res.code === 200) {
                res.data.forEach((item: any) => {
                    item.active = false
                    item.num = ''
                })
                cateList.value = res.data
            }
        })
    }

    const onConfirm2 = (e: string) => {
        let h = Number(e.substring(0, 2))
        let m = Number(e.substring(3, 5))
        let s = 0
        if (h > 0) {
            s += h * 60 * 60
        }
        if (m > 0) {
            s += m * 60
        }
        from.duration = s
        from.durationName = `${h}小时${m}分钟`
        TimeShow.value = false
    }

    const onCancel2 = () => {
        TimeShow.value = false
    }

    const onConfirm3 = () => {
        let isOpen = false
        cateList.value.forEach((item: any, index: number) => {
            if (item.active) {
                isOpen = true
            }
        })
        if (!isOpen) return Toast('请选择不良项')
        let arr: any = []
        let total: any = 0
        let name: any = ''
        cateList.value.forEach((item: any, index: number) => {
            if (item.active) {
                if (item.num <= 0) {
                    return Toast('不良数量必须大于0')
                }
                total = total += item.num
                arr.push(item)
                name += item.name + item.num + '；'
            }
        })
        if (total !== produceFrom.undesirable) return Toast('不良数必须等于产出不良数')
        from.defective = arr
        from.defectiveName = name
        show.value = false
    }

    // 投料统计
    const tlTotal = (): string => {
        if (feedingData.value.length > 0) {
            let total: number = 0
            feedingData.value.forEach((element: any) => {
                total = total + element.num
            })
            return `${total}`
        }
        return ''
    }

    // 修改产出
    const changeCC = (downType: string, num: number, recordId: string) => {
        if (!num) return
        if ((produceFrom.qualified + produceFrom.undesirable) > info.value.planNum) {
            return Toast.fail({ message: '产出数量不能大于计划数量', duration: 2000 })
        }
        if (num >= 0) {
            from.defective = []
            from.defectiveName = ''
            // dealWorkorderRecordStandard({
            //     downType, num, recordId, workorderId: route.query.id
            // }).then(res => {
            //     if (res.code === 200) {
            //         getOrocessRecordCC()
            //     }
            // })
        } else {
            if (downType == 0) {
                produceFrom.qualified = 0
            } else {
                produceFrom.undesirable = 0
            }
            Toast.fail({ message: '产出数量不能小于0', duration: 2000 })
        }
    }

    // 跳转点检
    const jumpdj = () => {
        router.push({ name: 'spotCheck', query: { id: route.query.id } })
    }

    // 删除点检
    const dele = (id: string | number): void => {
        deletedj(id)
            .then(res => {
                if (res.code === 200) {
                    djData.value = []
                    finished.value = false
                    page.page = 1
                    djData.value = []
                    pageDJs()
                }
            })
    }

    // 点检数据
    const pageDJs = () => {
        if (!finished.value) {
            page.page = page.page + 1
            loading.value = true
            pageDJ({
                capacity: page.capacity,
                page: page.page,
                model: {
                    workorderId: route.query.id
                }
            }).then(res => {
                if (res.code === 200 && res.data && res.data.records.length !== 0) {
                    djData.value.push(...res.data.records)
                } else {
                    finished.value = true
                }
                loading.value = false
            }).catch(err => {
                loading.value = false
                finished.value = true
            })
        }
    }

    // 统计
    const ccTotal = (): string => {
        if (produceData.value.length > 0) {
            let total: number = 0
            produceData.value.forEach((element: any) => {
                total = total + element.num
            })
            return `${total}${produceData.value[0].company}`
        }
        return ''
    }

    // 统计
    const blTotal = (): string => {
        if (undesirable.value.length > 0) {
            let total: number = 0
            undesirable.value.forEach((element: any) => {
                total = total + element.num
            })
            return `${total}${undesirable.value[0].company}`
        }
        return ''
    }

    // 统计
    const bfTotal = (): string => {
        if (scrap.value.length > 0) {
            let total: number = 0
            scrap.value.forEach((element: any) => {
                total = total + element.num
            })
            return `${total}${scrap.value[0].company}`
        }
        return ''
    }

    // 切换绩效类型
    const clickPerformanceType = (i: number) => {
        from.index = i
        arrType.value.forEach((item: any, index: number) => {
            if (i === index) {
                from.type = item.id
            }
            item.active = index === i
        })
    }

    // 删除产出/投料
    const deleItem = (id: any, type: string) => {
        Dialog.confirm({
            title: '提示',
            message: '确定删除此条记录吗？',
        }).then(() => {
            deleteCT(id)
                .then(res => {
                    if (res.code === 200 && type === 'C') {
                        getOrocessRecordCC()
                    } else if (res.code === 200 && type === 'T') {
                        getOrocessRecords()
                    }
                })
        }).catch(() => {
            // on cancel
        })
    }

    // 跳转手动产出
    const jumpCC = () => {
        router.push({ name: 'manualOutput', query: { id: route.query.id, num: produceData.value.length > 0 ? produceData.value[0].num : '' } })
    }

    // 跳转手动投料
    const jumpTL = () => {
        router.push({ name: 'manualFeeding', query: { id: route.query.id } })
    }

    // 关闭扫码组件
    const closePopup = (): void => {
        openCode.value = false
    }

    // 获取扫码值
    const onDecode = (data: string[]): void => {
        getBarcodeContent({
            barcode: data[0]
        }).then(res => {
            if (res.code === 200) {
                if (res.data.barcodeType === QRCodeType.GZ) {
                    if (type.value === 'tl') {    // 投料操作
                        getListByCondition({ id: res.data.id })
                            .then(gz => {
                                if (gz.code === 200) {
                                    if (gz.data[0].status !== 1) {
                                        router.push({ name: 'codeScanningFeeding', query: { id: route.query.id, gzId: res.data.id } })
                                    } else {
                                        Toast.fail({ message: '扫描的工装状态不能为空', duration: 2000 })
                                    }
                                }
                            })
                    }
                    if (type.value === 'cc') {    // 产出操作
                        router.push({ name: 'codeScanningOutput', query: { id: route.query.id, gzId: res.data.id } })
                    }
                } else {
                    Toast({ message: '请扫描正确的篮筐码', duration: 2000 })
                }
            }
        })
        nextTick(() => {
            openCode.value = false
        })
    }

    // 跳转手动投料
    const jump = () => {
        router.push({ name: 'manualFeeding', query: { id: route.query.id } })
    }

    // 跳转扫码投料
    const jump1 = (types: string) => {
        type.value = types
        openCode.value = true
    }

    // 查询工单详情
    const queryByIds = () => {
        queryById(route.query.id).then(res => {
            if (res.code === 200) {
                info.value = res.data
                // 获取工资绩效数据
                queryList({
                    deleted: 0,
                    departId: res.data.factoryId,
                    materialId: res.data.materialId,
                    procedureId: res.data.procedureId
                }).then((result: any) => {
                    if (result.code === 200) {
                        if (result.data && result.data.length > 0) {
                            result.data.forEach((item: any, index: number) => {
                                item.name = item.type == 0 ? '计件' : '计时'
                                item.id = item.type
                                item.active = index == 0
                            })
                            arrType.value = result.data
                        } else {
                            arrType.value = []
                        }
                        // infoBox.value = result.data
                    }
                    // if (result.code === 200) {
                    //     infoBox.value = result.data
                    // }
                })
            }
        })
    }

    // 查询工单生产记录---投料
    const getOrocessRecords = () => {
        feedingData.value = []
        allForStandard({
            workorderId: route.query.id,
            type: 0
        }).then(res => {
            if (res.code === 200) {
                feedingData.value = res.data
                // res.data.forEach((item: any) => {
                //     feedingData.value.push({ id: item.id, company: item.umodel.name, gz: item.amodel.code, name: item.mmodel.name, code: item.amodel.code + ' - ' + item.mmodel.name, num: item.num, ynum: item.num, maxNum: item.amodel.num })
                // })
            }
        })
    }

    // 查询工单生产记录---产出
    const getOrocessRecordCC = () => {
        produceData.value = []
        undesirable.value = []
        scrap.value = []
        getWorkorderRecordListStandard({
            workorderId: route.query.id
        }).then(res => {
            if (res.code === 200) {
                if (res.data.length > 0) {
                    res.data.forEach((item: any) => {
                        if (item.doneType === 1) {
                            produceFrom.undesirable = item.num
                            produceFrom.undesirableId = item.id
                        } else {
                            produceFrom.qualified = item.num
                            produceFrom.qualifiedId = item.id
                        }
                    })
                }
                // res.data.forEach((item: any) => {
                //     if (item.doneType === 0 || !item.doneType) { // 合格 | 混合

                //         produceData.value.push({ id: item.id, company: item.umodel.name, name: item.mmodel.name, code: item.amodel.code + ' - ' + item.mmodel.name, num: item.num, ynum: item.num, maxNum: item.amodel.num })
                //     } else if (item.doneType === 1) { // 不良
                //         undesirable.value.push({ id: item.id, company: item.umodel.name, name: item.mmodel.name, code: item.amodel.code + ' - ' + item.mmodel.name, num: item.num, ynum: item.num, maxNum: item.amodel.num })
                //     } else if (item.doneType === 2) { // 报废
                //         scrap.value.push({ id: item.id, company: item.umodel.name, name: item.mmodel.name, code: item.amodel.code + ' - ' + item.mmodel.name, num: item.num, ynum: item.num, maxNum: item.amodel.num })
                //     }
                // })
            }
        })
    }

    // 编辑投料/产出
    const change = (id: any, num: any, type: any, maxNum: number, item: object, unitAttribute: number): void => {
        let obj: any = item
        if (type === 'T') {
            if (unitAttribute == 0 && num != '') {
                if(!REGULAR.positiveInteger.test(num)){
                    obj.num = obj.ynum
                    Toast({ message: '只能输入正整数' })
                    return
                }
            }
            if (unitAttribute == 1 && num != '') {
                if(!REGULAR.number.test(num)){
                    Toast({ message: '只能输入正整数或小数（最多四位）' })
                    obj.num = obj.ynum
                    return
                }
            }
            if (num > maxNum) {
                obj.num = obj.ynum
                Toast.fail({ message: '超出工装总数' })
                return
            }
        } else if (type === 'C' && num > info.value.planNum) {
            obj.num = obj.ynum
            Toast.fail({ message: '产出数量不能超过计划数量' })
            return
        }
        updateById({ id: id, num: num }).then(res => {
            if (res.code === 200 && type === 'T') {
                getOrocessRecords()
            } else if (res.code === 200 && type === 'C') {
                // getOrocessRecordCC()
            }
        })
    }

    // 确认报工
    const submit = () => {
        if (info.value.bomType === 1) {  // 拉式
            console.log('拉式')
            statisticsData.value = []
            if (produceFrom.qualified <= 0) {
                Toast.fail({ message: '产出明细不能为空' })
                return
            }
            if (info.value.hasBom === 0) {
                console.log('无bom')
                // let data: any = [
                //     { name: '工单投料', gznum: feedingData.value.length, wlmc: feedingData.value.length > 0 ? feedingData.value[0].name : '', wlnum: 0 },
                //     { name: '工单合格产出', gznum: produceData.value.length, wlmc: produceData.value.length > 0 ? produceData.value[0].name : '', wlnum: 0 },
                //     { name: '工单不良产出', gznum: 0, wlmc: '', wlnum: 0 },
                //     { name: '工单未投料', gznum: '', wlmc: feedingData.value.length > 0 ? feedingData.value[0].name : '', wlnum: 0 }
                // ]
                // if (undesirable.value.length > 0) {   // 判断有没有不良
                //     data[2].wlmc = undesirable.value[0].name
                //     data[2].gznum = data[2].gznum + undesirable.value.length
                // }
                // if (scrap.value.length > 0) {   // 判断有没有不良
                //     data[2].wlmc = scrap.value[0].name
                //     data[2].gznum = data[2].gznum + scrap.value.length
                // }
                // let tl: number = 0
                // let cc: number = 0
                // let bl: number = 0
                // undesirable.value.forEach((item: any) => {  // 不良
                //     bl = bl + item.num
                // })
                // scrap.value.forEach((item: any) => {  // 报废
                //     bl = bl + item.num
                // })
                // if (produceData.value.length > 0) {   // 判断有没有合格产出
                //     produceData.value.forEach((item: any) => {  // 产出
                //         cc = cc + item.num
                //     })
                // }
                // feedingData.value.forEach((item: any) => {  // 投料
                //     tl = tl + item.num
                // })
                // data[0].wlnum = tl.toString() + info.value.umodel.name
                // if (produceData.value.length > 0) {
                //     data[1].wlnum = cc.toString() + info.value.umodel.name
                // }
                // data[2].wlnum = bl.toString() + info.value.umodel.name
                // let total: number = info.value.planNum - (Number(cc) + Number(bl))
                // data[data.length - 1].wlnum = (info.value.planNum - Number(cc) - Number(bl)).toString() + info.value.umodel.name
                // if (total === 0) {
                //     isSubmit.value = true
                // } else {
                //     isSubmit.value = false
                // }

                let arr: any = []
                let tl = 0
                let res = getGroupNum(feedingData.value)
                for (let i in res) {
                    let num = 0
                    res[i].forEach((item: any) => {
                        num += item.num
                    })
                    arr.push({ name: '工单投料', materialName: i + res[i][0].procedureName, num: num })
                }
                feedingData.value.forEach((item: any) => {
                    tl += item.num
                })
                statisticsData.value = [...statisticsData.value, ...arr]
                statisticsData.value.push({ name: '工单合格产出', materialName:  info.value.mmodel.name + '-' + info.value.procedureName, num: produceFrom.qualified })
                statisticsData.value.push({ name: '工单不良产出', materialName:  info.value.mmodel.name + '-' + info.value.procedureName, num: produceFrom.undesirable })
                statisticsData.value.push({ name: '工单未投料', materialName: '', num: info.value.planNum - Number(produceFrom.qualified) - Number(produceFrom.undesirable) })
                let total: number = info.value.planNum - (Number(produceFrom.qualified) + Number(produceFrom.undesirable))
                if (total === 0) {
                    isSubmit.value = true
                } else {
                    isSubmit.value = false
                }
                // if (Number(tl) <= info.value.planNum) {
                //   let total: number = Number(tl) - Number(cc) - Number(bl)  // 是否有余
                //   data[data.length - 1].wlnum = (Number(tl) - Number(cc) - Number(bl)).toString() + info.value.umodel.name
                //   if (total === 0) {
                //     isSubmit.value = true
                //   } else {
                //     isSubmit.value = false
                //   }
                // } else {
                //   isSubmit.value = false
                // }
                // statisticsData.value = data
            } else if (info.value.hasBom === 1) {  // 有bom情况
                console.log('有bom')
                // let cc: number = 0
                // let bl: number = 0
                // let newData: any = {}
                // if (feedingData.value.length > 0) {  // 投料
                //     feedingData.value.forEach((e: any) => {
                //         if (Object.keys(newData).indexOf('' + e.name) === -1) {
                //             newData[e.name] = []
                //         }
                //         newData[e.name].push(e)
                //     })
                //     for (let key in newData) {
                //         let obj = { name: '工单投料', gznum: newData[key].length, wlmc: key, wlnum: 0, num: 0 }
                //         newData[key].forEach((item: any) => {
                //             obj.wlnum = obj.wlnum + item.num
                //             obj.num = item.num
                //         })
                //         obj.wlnum = obj.wlnum.toString() + newData[key][0].company as never
                //         statisticsData.value.push(obj)
                //     }
                // }
                // if (produceData.value.length > 0) {  // 产出
                //     produceData.value.forEach((item: any) => {
                //         cc = cc + item.num
                //     })
                //     statisticsData.value.push({ name: '工单合格产出', gznum: produceData.value.length, wlmc: info.value.mmodel.name, wlnum: cc + info.value.umodel.name, num: cc })
                // }
                // if (undesirable.value.length > 0 || scrap.value.length > 0) {  // 不良/报废
                //     undesirable.value.forEach((item: any) => {
                //         bl = bl + item.num
                //     })
                //     scrap.value.forEach((item: any) => {
                //         bl = bl + item.num
                //     })
                //     statisticsData.value.push({ name: '工单不良产出', gznum: undesirable.value.length + scrap.value.length, wlmc: info.value.mmodel.name, wlnum: bl + info.value.umodel.name, num: bl })
                // }
                // let totaltl: number = 0
                // let totalcc: number = 0
                // let totalbl: number = 0
                // statisticsData.value.forEach((item: any) => {
                //     if (item.name === '工单投料') {
                //         totaltl = totaltl + item.num
                //     } else if (item.name === '工单合格产出') {
                //         totalcc = totalcc + item.num
                //     } else if (item.name === '工单不良产出') {
                //         totalbl = totalbl + item.num
                //     }
                // })
                // isSubmit.value = totalcc + totalbl <= info.value.planNum;
                let arr: any = []
                let tl = 0
                let res = getGroupNum(feedingData.value)
                for (let i in res) {
                    let num = 0
                    res[i].forEach((item: any) => {
                        num += item.num
                    })
                    arr.push({ name: '工单投料', materialName: i, num: num })
                }
                feedingData.value.forEach((item:any) => {
                    tl += item.num
                })
                statisticsData.value = [...statisticsData.value, ...arr]
                statisticsData.value.push({ name: '工单合格产出', materialName:  info.value.mmodel.name + '-' + info.value.procedureName, num: produceFrom.qualified })
                statisticsData.value.push({ name: '工单不良产出', materialName:  info.value.mmodel.name + '-' + info.value.procedureName, num: produceFrom.undesirable })
                isSubmit.value = produceFrom.qualified + produceFrom.undesirable <= info.value.planNum;
            }
        } else {
            console.log('推式')
            if (feedingData.value.length === 0) {
                Toast.fail({ message: '投料明细不能为空' })
                return
            }
            if (produceFrom.qualified <= 0) {
                Toast.fail({ message: '产出明细不能为空' })
                return
            }
            statisticsData.value = []
            if (info.value.hasBom === 0) {
                console.log('无bom')
                // let data: any = [
                //     { name: '工单投料', gznum: feedingData.value.length, wlmc: feedingData.value.length > 0 ? feedingData.value[0].name : '', wlnum: 0 },
                //     { name: '工单合格产出', gznum: produceData.value.length, wlmc: produceData.value.length > 0 ? produceData.value[0].name : '', wlnum: 0 },
                //     { name: '工单不良产出', gznum: 0, wlmc: '', wlnum: 0 },
                //     { name: '工单未投料', gznum: '', wlmc: feedingData.value.length > 0 ? feedingData.value[0].name : '', wlnum: 0 }
                // ]
                // if (undesirable.value.length > 0) {   // 判断有没有不良
                //     data[2].wlmc = undesirable.value[0].name
                //     data[2].gznum = data[2].gznum + undesirable.value.length
                // }
                // if (scrap.value.length > 0) {   // 判断有没有不良
                //     data[2].wlmc = scrap.value[0].name
                //     data[2].gznum = data[2].gznum + scrap.value.length
                // }
                // let tl = 0
                // let cc = 0
                // let bl = 0
                // undesirable.value.forEach((item: any) => {  // 不良
                //     bl = bl + item.num
                // })
                // scrap.value.forEach((item: any) => {  // 报废
                //     bl = bl + item.num
                // })
                // if (produceData.value.length > 0) {   // 判断有没有合格产出
                //     produceData.value.forEach((item: any) => {  // 产出
                //         cc = cc + item.num
                //     })
                // }
                // feedingData.value.forEach((item: any) => {  // 投料
                //     tl = tl + item.num
                // })
                // data[0].wlnum = tl.toString() + info.value.umodel.name
                // if (produceData.value.length > 0) {
                //     data[1].wlnum = cc.toString() + info.value.umodel.name
                // }
                // data[2].wlnum = bl.toString() + info.value.umodel.name
                // if (Number(tl) <= info.value.planNum) {
                //     let total: number = Number(tl) - Number(cc) - Number(bl)  // 是否有余
                //     data[data.length - 1].wlnum = (Number(tl) - Number(cc) - Number(bl)).toString() + info.value.umodel.name
                //     if (total === 0) {
                //         isSubmit.value = true
                //     } else {
                //         isSubmit.value = false
                //     }
                // } else {
                //     isSubmit.value = false
                // }
                // statisticsData.value = data
                let arr: any = []
                let tl = 0
                let res = getGroupNum(feedingData.value)
                for (let i in res) {
                    let num = 0
                    res[i].forEach((item: any) => {
                        num += item.num
                    })
                    arr.push({ name: '工单投料', materialName: i + '-' + res[i][0].procedureName, num: num })
                }
                feedingData.value.forEach((item:any) => {
                    tl += item.num
                })
                statisticsData.value = [...statisticsData.value, ...arr]
                statisticsData.value.push({ name: '工单合格产出', materialName: info.value.mmodel.name + '-' + info.value.procedureName, num: produceFrom.qualified })
                statisticsData.value.push({ name: '工单不良产出', materialName: info.value.mmodel.name + '-' + info.value.procedureName, num: produceFrom.undesirable })
                if (Number(tl) <= info.value.planNum) {
                    let total: number = Number(tl) - Number(produceFrom.qualified) - Number(produceFrom.undesirable)  // 是否有余
                    statisticsData.value.push({ name: '工单未投料', materialName: '', num: (Number(tl) - Number(produceFrom.qualified) - Number(produceFrom.undesirable)).toFixed(2) })
                    if (total === 0) {
                        isSubmit.value = true
                    } else {
                        isSubmit.value = false
                    }
                } else {
                    isSubmit.value = false
                }
            } else if (info.value.hasBom === 1) {  // 有bom情况
                console.log('有bom')
                let arr: any = []
                let tl = 0
                let res = getGroupNum(feedingData.value)
                for (let i in res) {
                    let num = 0
                    res[i].forEach((item: any) => {
                        num += item.num
                    })
                    arr.push({ name: '工单投料', materialName: i, num: num })
                }
                feedingData.value.forEach((item:any) => {
                    tl += item.num
                })
                statisticsData.value = [...statisticsData.value, ...arr]
                statisticsData.value.push({ name: '工单合格产出', materialName: info.value.mmodel.name + '-' + info.value.procedureName, num: produceFrom.qualified })
                statisticsData.value.push({ name: '工单不良产出', materialName: info.value.mmodel.name + '-' + info.value.procedureName, num: produceFrom.undesirable })
                // isSubmit.value = produceFrom.qualified + produceFrom.undesirable <= info.value.planNum;
                isSubmit.value = true
            }
        }
        statistics.value = true
    }

    // 根据某个字段进行分组
    const getGroupNum = (arr: any) => {
        let newArry: any = {};
        for (let i = 0; i < arr.length; i++) {
            if (newArry[arr[i].materialName]) {
                newArry[arr[i].materialName].push(arr[i])
            } else {
                newArry[arr[i].materialName] = [arr[i]]
            }
        }
        return newArry;
    }

    // 返回修改
    const gofh = () => {
        statistics.value = false
    }

    // 确认报工
    const submitBG = () => {
        // if (!from.duration || from.duration <= 0) {
        //     return Toast('报工时长不能为空')
        // }
        let createUnqualifiedDTOList = from.defective.map((item: any) => {
            return {
                categoryId: item.id,
                unQualifiedNum: item.num
            }
        })
        let createWorkorderRecordDTO = {
            workorderId: route.query.id,
            duration: from.duration ? from.duration : 0,
            qualifiedNum: produceFrom.qualified ? produceFrom.qualified : 0,
            unQualifiedNum: produceFrom.undesirable ? produceFrom.undesirable : 0
        }
        // id: route.query.id
        comfirmDoneStandard({
            createUnqualifiedDTOList,
            createWorkorderRecordDTO
        }).then(res => {
            if (res.code === 200) {
                Toast.success({ message: '报工成功', forbidClick: true, duration: 2000 })
                setTimeout(() => {
                    router.go(-2)
                }, 2000)
            }
        })
    }

    onActivated(() => {
        // $Bus.on('callback1', (res: any)=>{
        //     console.log(res)
        //     if (res == 1) {
        //         djData.value = []
        //         finished.value = false
        //         page.page = 1
        //         djData.value = []
        //         pageDJs()
        //     }
        // })
        // queryByIds()
        // getOrocessRecords()
        // getData()
    })

    onMounted(() => {
        // $Bus.on('callback1', (res: any)=>{
        //     if (res == 1) {
        //         djData.value = []
        //         finished.value = false
        //         page.page = 1
        //         djData.value = []
        //         pageDJs()
        //     }
        // })
        // pageDJs()

        queryByIds()
        getOrocessRecords()
        getData()

        // getOrocessRecordCC()
    })

return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_swipe_cell = _resolveComponent("van-swipe-cell")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_v_ScanCode = _resolveComponent("v-ScanCode")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(VWorkOrderInfo, { info: info.value }, null, 8, ["info"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cate), (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          onClick: ($event: any) => (clickIten(index)),
          class: _normalizeClass(_unref(typeView) == index ? 'bg_cate_item active' : 'bg_cate_item'),
          key: index
        }, _toDisplayString(item.name), 11, _hoisted_3))
      }), 128))
    ]),
    (_unref(typeView) === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              (_unref(proxy).$auth('h5:workorderinput:create') && (info.value.bomType !== 1 || info.value.bomType == 0 || !info.value.bomType))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "bg_list_item_top_right",
                    onClick: jumpTL
                  }, _hoisted_10))
                : _createCommentVNode("", true)
            ]),
            (feedingData.value && feedingData.value.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(feedingData.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_van_swipe_cell, { key: index }, _createSlots({
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("span", null, _toDisplayString(item.materialName) + _toDisplayString(item.procedureName ? ` | ${item.procedureName}` : ''), 1),
                              _createElementVNode("div", _hoisted_15, [
                                (item.qualityType == 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, "合格 / "))
                                  : _createCommentVNode("", true),
                                (item.qualityType == 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, "不良 / "))
                                  : _createCommentVNode("", true),
                                (item.qualityType == 2)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, "报废 / "))
                                  : _createCommentVNode("", true),
                                _createElementVNode("span", null, _toDisplayString(item.locationName), 1),
                                _createElementVNode("span", null, _toDisplayString(item.batch ? ` / ${item.batch}` : ''), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((item.num) = $event),
                                disabled: !_unref(proxy).$auth('h5:workorderinput:update'),
                                onBlur: ($event: any) => (change(item.id, item.num, 'T', item.maxNum, item, item.unitAttribute)),
                                type: "number"
                              }, null, 40, _hoisted_20), [
                                [_vModelText, item.num]
                              ]),
                              _createElementVNode("span", null, _toDisplayString(item.unitName), 1)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 2
                  }, [
                    (_unref(proxy).$auth('h5:workorderinput:delete'))
                      ? {
                          name: "right",
                          fn: _withCtx(() => [
                            _createVNode(_component_van_button, {
                              style: {"height":"100%"},
                              square: "",
                              text: "删除",
                              onClick: ($event: any) => (deleItem(item.id, 'T')),
                              type: "danger"
                            }, null, 8, ["onClick"])
                          ])
                        }
                      : undefined
                  ]), 1024))
                }), 128))
              : (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createVNode(_component_van_swipe_cell, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("span", null, "良品数(" + _toDisplayString(info.value.umodel ? info.value.umodel.name : '') + ")", 1),
                      _createElementVNode("div", _hoisted_29, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(produceFrom).qualified) = $event)),
                          onBlur: _cache[1] || (_cache[1] = ($event: any) => (changeCC('0', _unref(produceFrom).qualified, _unref(produceFrom).qualifiedId))),
                          placeholder: "请输入"
                        }, null, 544), [
                          [_vModelText, _unref(produceFrom).qualified]
                        ]),
                        (info.value.umodel)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(info.value.umodel.name), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_van_swipe_cell, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("span", null, "不良数(" + _toDisplayString(info.value.umodel ? info.value.umodel.name : '') + ")", 1),
                      _createElementVNode("div", _hoisted_34, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(produceFrom).undesirable) = $event)),
                          onBlur: _cache[3] || (_cache[3] = ($event: any) => (changeCC('1', _unref(produceFrom).undesirable, _unref(produceFrom).undesirableId))),
                          placeholder: "请输入"
                        }, null, 544), [
                          [_vModelText, _unref(produceFrom).undesirable]
                        ]),
                        (info.value.umodel)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(info.value.umodel.name), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            (_unref(produceFrom).undesirable > 0)
              ? (_openBlock(), _createBlock(_component_van_swipe_cell, { key: 0 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", {
                          class: "bg_list_item_num_item",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_isRef(show) //@ts-ignore
 ? show.value = true : show = true))
                        }, [
                          _hoisted_38,
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("span", {
                              class: "wulll",
                              style: _normalizeStyle({color: _unref(from).defectiveName ? '#305ED5' : ''})
                            }, _toDisplayString(_unref(from).defectiveName ? _unref(from).defectiveName : '设置'), 5),
                            _hoisted_40
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: "bg_plan",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_isRef(TimeShow) //@ts-ignore
 ? TimeShow.value = true : TimeShow = true))
          }, [
            _hoisted_41,
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("span", {
                style: _normalizeStyle({color: _unref(from).durationName ? '#333' : ''})
              }, _toDisplayString(_unref(from).durationName ? _unref(from).durationName : '请选择'), 5),
              _hoisted_43
            ])
          ]),
          (_unref(arrType) && _unref(arrType).length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _hoisted_45,
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _hoisted_49,
                      _createElementVNode("div", _hoisted_50, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(arrType), (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(item.active ? 'bg_list_item_num_item_list_item active' : 'bg_list_item_num_item_list_item'),
                            key: index,
                            onClick: ($event: any) => (clickPerformanceType(index))
                          }, _toDisplayString(item.name), 11, _hoisted_51))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _hoisted_54,
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("span", _hoisted_56, _toDisplayString((_unref(arrType)[_unref(from).index].salary / 10 / 10).toFixed(2)) + "元/" + _toDisplayString(_unref(arrType)[_unref(from).index].type == 0 ? '件' : '时'), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _hoisted_59,
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("span", _hoisted_61, _toDisplayString(_unref(expectedSalary)) + "元", 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _hoisted_64,
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("span", _hoisted_66, _toDisplayString(_unref(complianceRate)) + "%", 1)
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(typeView) === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
          _createElementVNode("div", _hoisted_68, [
            _createVNode(_component_van_list, {
              loading: loading.value,
              "onUpdate:loading": _cache[6] || (_cache[6] = ($event: any) => ((loading).value = $event)),
              finished: finished.value,
              "finished-text": "没有更多了~",
              onLoad: pageDJs
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(djData), (item, index) => {
                  return (_openBlock(), _createBlock(_component_van_swipe_cell, { key: index }, {
                    right: _withCtx(() => [
                      _createVNode(_component_van_button, {
                        square: "",
                        type: "danger",
                        style: {"height":"100%"},
                        onClick: ($event: any) => (dele(item.id)),
                        text: "删除"
                      }, null, 8, ["onClick"])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("span", null, _toDisplayString(item.attrName) + "：" + _toDisplayString(item.val), 1),
                        _createElementVNode("span", null, _toDisplayString(item.userName) + " " + _toDisplayString(item.createTime), 1)
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["loading", "finished"])
          ])
        ]))
      : _createCommentVNode("", true),
    (info.value.status === 2 || info.value.procedureNeedcheck === 1)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _hoisted_70,
          _createElementVNode("div", _hoisted_71, [
            (_unref(typeView) == 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "bg_footer_submit",
                  onClick: submit
                }, "确认报工"))
              : _createCommentVNode("", true),
            (_unref(proxy).$auth('h5:workorder:processRecord') && _unref(typeView) == 1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "bg_footer_submit1",
                  onClick: jumpdj
                }, _hoisted_74))
              : _createCommentVNode("", true)
          ])
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_v_ScanCode, {
      openCode: openCode.value,
      infos: ['请扫描工装码'],
      onClosePopup: closePopup,
      onOnDecode: onDecode
    }, null, 8, ["openCode"]),
    _createVNode(_component_van_popup, {
      show: statistics.value,
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((statistics).value = $event)),
      round: "",
      closeable: true,
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_75, [
          _hoisted_76,
          _createElementVNode("div", _hoisted_77, [
            _hoisted_78,
            (_unref(statisticsData).length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(statisticsData), (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "tg_table_nr",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_80, _toDisplayString(item.name), 1),
                      _createElementVNode("div", _hoisted_81, _toDisplayString(item.materialName), 1),
                      _createElementVNode("div", {
                        class: "tg_table_nr_item",
                        style: _normalizeStyle(item.name === '工单未投料' ? 'color: #DE5243' : '')
                      }, _toDisplayString(item.num), 5)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_82, _hoisted_84))
          ]),
          _createElementVNode("div", _hoisted_85, [
            (_unref(proxy).$auth('h5:workorderoutput:confirm') && _unref(isSubmit))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "tg_footer_qr",
                  onClick: submitBG
                }, "确认报工"))
              : (!_unref(isSubmit))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "tg_footer_fh",
                    onClick: gofh
                  }, "返回修改"))
                : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _unref(TimeShow),
      "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => (_isRef(TimeShow) ? (TimeShow).value = $event : TimeShow = $event)),
      round: "",
      position: "bottom",
      style: { height: '50%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_datetime_picker, {
          modelValue: _unref(from).time,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(from).time) = $event)),
          type: "time",
          title: "选择时间",
          onConfirm: onConfirm2,
          onCancel: onCancel2
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _unref(show),
      "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => (_isRef(show) ? (show).value = $event : show = $event)),
      round: "",
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_86, [
          _createElementVNode("div", _hoisted_87, [
            _hoisted_88,
            _hoisted_89,
            _createElementVNode("img", {
              src: _imports_2,
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_isRef(show) //@ts-ignore
 ? show.value = false : show = false)),
              alt: ""
            })
          ]),
          _createElementVNode("div", _hoisted_90, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cateList), (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "bl_list_item",
                key: i,
                onClick: ($event: any) => (changeChecked(i))
              }, [
                _createElementVNode("div", _hoisted_92, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: item.active
                  }, null, 8, _hoisted_93),
                  _createElementVNode("span", null, _toDisplayString(item.name), 1)
                ]),
                _createElementVNode("div", _hoisted_94, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"])),
                    "onUpdate:modelValue": ($event: any) => ((item.num) = $event),
                    placeholder: "0"
                  }, null, 8, _hoisted_95), [
                    [_vModelText, item.num]
                  ])
                ])
              ], 8, _hoisted_91))
            }), 128))
          ]),
          _createElementVNode("div", {
            class: "bl_footer",
            onClick: onConfirm3
          }, "确认")
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})